// Group track years into buckets, anchored on the current year.
// Recent years get fine-grained buckets (current year alone, the two years
// before that, and the four years before that). Anything older falls into
// decade-aligned buckets ("10s", "00s", "90s", ...). Empty buckets are
// dropped so the chart only shows ranges with actual tracks.
export function getGroupYears(yearData) {
    const now = new Date().getFullYear();

    // Two-digit year label like 26, 24, 99. Wraps cleanly across centuries.
    const yy = (year) => String(year % 100).padStart(2, '0');

    // Recent (year-relative) buckets, oldest-to-newest within the recent window.
    const recentBuckets = [
        { start: now - 6, end: now - 3, label: `${yy(now - 6)}-${yy(now - 3)}` }, // e.g. 20-23
        { start: now - 2, end: now - 1, label: `${yy(now - 2)}-${yy(now - 1)}` }, // e.g. 24-25
        { start: now,     end: now,     label: yy(now) },                          // e.g. 26
    ];

    // Decade buckets covering everything before the recent window, down to 1950.
    const recentWindowStart = now - 6;
    const decadeBuckets = [];
    let decadeStart = Math.floor((recentWindowStart - 1) / 10) * 10;
    while (decadeStart >= 1950) {
        decadeBuckets.push({
            start: decadeStart,
            end: decadeStart + 9,
            label: `${yy(decadeStart)}s`,
        });
        decadeStart -= 10;
    }

    // Render order: oldest decade first, then recent buckets in order.
    const buckets = [...decadeBuckets.reverse(), ...recentBuckets];

    const counts = buckets.map((b) => ({ ...b, count: 0 }));
    for (const [year, c] of Object.entries(yearData)) {
        const y = parseInt(year, 10);
        if (!Number.isFinite(y)) continue;
        const bucket = counts.find((b) => y >= b.start && y <= b.end);
        if (bucket) bucket.count += c;
    }

    return counts
        .filter((b) => b.count > 0)
        .map((b) => ({ year: b.label, count: b.count }));
}
